import { render, staticRenderFns } from "./sumContent.vue?vue&type=template&id=6db2bcb4"
import script from "./sumContent.vue?vue&type=script&lang=js"
export * from "./sumContent.vue?vue&type=script&lang=js"
import style0 from "./sumContent.vue?vue&type=style&index=0&id=6db2bcb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports